import { Link, useLocation, useNavigate } from "react-router-dom";
import { Truck, Phone, LayoutDashboard, LogOut } from "lucide-react";
import { Button } from "@/components/ui/button";
import { useAuth } from "@/context/AuthContext";

const Navbar = () => {
  const { pathname } = useLocation();
  const navigate = useNavigate();
  const { user, logout } = useAuth();

  const goRequest = () => {
    if (pathname !== "/") {
      navigate("/");
      setTimeout(() => document.getElementById("aanvraag")?.scrollIntoView({ behavior: "smooth" }), 200);
    } else {
      document.getElementById("aanvraag")?.scrollIntoView({ behavior: "smooth" });
    }
  };

  return (
    <header
      data-testid="navbar"
      className="sticky top-0 z-[1000] backdrop-blur-xl bg-slate-950/80 border-b border-slate-800/80 px-4 lg:px-8 py-3 flex items-center justify-between"
    >
      <Link to="/" data-testid="nav-logo" className="flex items-center gap-2.5 group">
        <div className="relative flex items-center justify-center w-10 h-10 rounded-xl bg-sky-500 glow-blue">
          <Truck className="w-6 h-6 text-slate-950" strokeWidth={2.2} />
        </div>
        <div className="leading-tight">
          <span className="font-heading font-extrabold text-white text-lg tracking-tight">Takeldienst</span>
          <span className="block text-[10px] font-semibold text-sky-400 tracking-[0.2em] uppercase">24/7 Pechhulp</span>
        </div>
      </Link>

      <nav className="hidden md:flex items-center gap-1">
        <button onClick={goRequest} data-testid="nav-request" className="px-4 py-2 text-sm font-medium text-slate-300 hover:text-white transition-colors">
          Takelverzoek
        </button>
        <Link to="/dashboard" data-testid="nav-dashboard" className={`px-4 py-2 text-sm font-medium transition-colors flex items-center gap-1.5 ${pathname === "/dashboard" ? "text-sky-400" : "text-slate-300 hover:text-white"}`}>
          <LayoutDashboard className="w-4 h-4" /> Dashboard
        </Link>
      </nav>

      <div className="flex items-center gap-2">
        {user && (
          <Button onClick={() => { logout(); navigate("/"); }} data-testid="nav-logout" variant="outline" className="rounded-full border-slate-700 text-slate-200 hover:bg-slate-800 gap-2">
            <LogOut className="w-4 h-4" /> <span className="hidden sm:inline">Uitloggen</span>
          </Button>
        )}
        <a href="tel:+32493967469" data-testid="nav-call-btn">
          <Button className="rounded-full bg-sky-500 hover:bg-sky-400 text-slate-950 font-semibold gap-2 glow-blue">
            <Phone className="w-4 h-4" />
            <span className="hidden sm:inline">0493967469</span>
          </Button>
        </a>
      </div>
    </header>
  );
};

export default Navbar;
